import {
  enqueueSnackbar,
  type OptionsWithExtraProps,
  type VariantType,
} from "notistack";

export const showSnackbar = (
  message: string,
  variant: VariantType = "success",
  props: OptionsWithExtraProps<"default"> = {}
) => {
  enqueueSnackbar(message, {
    variant,
    ...props,
  });
};
